<template>
  <div class="section__wrapper report__wrapper">
    <div
      v-if="filters.length > 0"
      class="report__filters"
    >
      <div
        v-for="(filter, index) in filters"
        :key="`report_filter_${index}`"
        class="report__filters-item"
      >
        <label class="report__filters-label">
          {{ filter.label }}
        </label>

        <template v-if="filter.type === 'date'">
          <div class="report__filters-field">
            <dr-datepicker
              v-model="filter.value"
              type="calendar"
              @change="validatePeriods()"
            />
          </div>
        </template>

        <template v-if="filter.type === 'list'">
          <div class="report__filters-field">
            <dr-select-list
              v-model.lazy="filter.value"
              :options="filter.options"
            />
          </div>
        </template>

        <template v-if="filter.type === 'text'">
          <div class="report__filters-field">
            <input
              v-model="filter.value"
              :placeholder="filter.placeholder"
              type="text"
              class="report__filters-text"
            >

            <i
              v-show="filter.value"
              class="icon icon-cross report__filters-reset"
              @click="filter.value = null"
            />
          </div>
        </template>
      </div>
    </div>

    <div class="report__body">
      <template
        v-if="Array.isArray(data.rows) && data.rows.length > 0"
        tag="div"
        class="report__table"
      >
        <header
          v-if="fn_IS_MOBILE()"
          class="report__table-header mobile"
          :class="$store.getters.getNewCertifierCredentialRequired ? 'withCredentials' : '' ">
          <div
            :class="data.keys[0].class"
            class="report__table-col"
          >
            {{ data.keys[0].title }}
          </div>
          <div class="report__table-col">
            <select v-model="ui.selectedCol">
              <template v-for="(key, index) in data.keys">
                <option
                  v-if="index > 0 && key.name !== 'actions'"
                  :value="key.name" :key="`option${key.title}`">{{ key.title }}</option>
              </template>
            </select>
          </div>
        </header>

        <div v-else class="report__table-header">
          <div
            v-for="(key, index) in data.keys"
            :key="`report-header_item${index}`"
            :class="key.class"
            class="report__table-col"
          >
            {{ key.title }}
          </div>
        </div>

        <div
          v-for="(row, index) in getRows"
          :key="`report_table_row_${index}`"
          class="report__table-row  pb-6"
        >
          <div class="report__table-cell report__table-cell--15">
            <span class="report__table-cell--highlight">
              {{ row['patientName'] }}

              <template v-if="fn_IS_MOBILE()">
                <div class="report__table-cell--actions absolute">
                  <div
                    v-for="(action, index) in getActions(index)"
                    :key="`row-action-${index}`"
                    class="mt-2"
                  >
                    <template v-if="action.type === 'icon'">
                      <i
                        :class="`icon icon-${action.icon} clickable`"
                        @click="$router.push(action.route)"
                      />
                    </template>

                    <template v-if="action.type === 'label'">
                      <span
                        :class="action.class"
                        class="appointment-label"
                        @click.prevent="
                          'route' in action
                            ? $router.push(action.route)
                            : action.fn.apply(null, action.params)
                        "
                      >
                        {{ action.label }}
                      </span>
                    </template>
                  </div>
                </div>
              </template>
            </span>
          </div>

          <div v-if="row['patientContactPhone']" class="report__table-cell report__table-cell--12">
            <span>
              {{ row['patientContactPhone'] || '(não informado)' | TO_TEL}}
            </span>
          </div>

          <div v-if="row['type']" class="report__table-cell report__table-cell--17">
            <span>
              {{
                row['type'] === 'CONVENIO'
                  ? 'Convênio'
                  : row['type'].replace('_', ' ').replace('DRCONECTA', 'Dr. Conecta')
                | TO_CAPITALIZE
              }}
            </span>
          </div>

          <div v-if="row['medicalConsultationType']" class="report__table-cell report__table-cell--15">
            <span>
              {{ row['medicalConsultationType'].replace('_', '/') | TO_MEDICAL_CONSULTATION_TYPE }}
            </span>
          </div>

          <div v-if="row['agendaAppointmentStart']" class="report__table-cell report__table-cell--15">
            <span>
              {{ row['agendaAppointmentStart'] | TO_DATE_TIME }}
            </span>
          </div>

          <div v-if="!fn_IS_MOBILE()" class="report__table-cell report__table-cell--26 report__table-cell--actions">
            <div
              v-for="(action, index) in getActions(index)"
              :key="`row-action-${index}`"
            >
              <template v-if="action.type === 'icon'">
                <i
                  :class="`icon icon-${action.icon} clickable text-blue`"
                  @click="$router.push(action.route)"
                />
              </template>

              <template v-if="action.type === 'label'">
                <span
                  :class="action.class"
                  class="appointment-label"
                  @click.prevent="
                    'route' in action
                      ? $router.push(action.route)
                      : action.fn.apply(null, action.params)
                  "
                >
                  {{ action.label }}
                </span>
              </template>
            </div>
          </div>
        </div>
      </template>

      <dr-loader
        v-if="ui.isLoading"
        size="lg"
        class="report__loader"
      />

      <p
        v-if="!ui.isLoading && Array.isArray(data.rows) && data.rows.length === 0"
        class="report__no-results"
      >
        Nenhum resultado encontrado.
      </p>
    </div>

    <footer
      v-show="
        ui.hasLoaded &&
        pagination.totalPages > 1 &&
        pagination.currentPage < pagination.totalPages
      "
      class="finances-statement__footer"
    >
      <button
        class="btn btn-primary finances-statement__footer-see-more"
        @click="showMore()"
      >
        <span>Ver mais</span>
      </button>
    </footer>

    <dr-receipt
      v-if="ui.showReceipt"
      :id.sync="agendaId"
      @close="ui.showReceipt = false"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import DrDatepicker from '@/components/form/datepicker'
import DrSelectList from '@/components/form/selectList'
import DrReceipt from '@/components/layout/appointments/receipt'

export default {
  name: 'DrAppointmentsList',

  filters: {
    TO_MEDICAL_CONSULTATION_TYPE (v) {
      return /\//.test(v)
        ? v.split('/')
          .map(i => i.charAt(0).toUpperCase() + i.slice(1).toLowerCase())
          .join('/')
        : v.charAt(0).toUpperCase() + v.slice(1).toLowerCase()
    }
  },

  props: {
    doctor: {
      type: Object,
      required: true
    }
  },

  components: {
    DrDatepicker,
    DrSelectList,
    DrReceipt
  },

  data () {
    return {
      data: {
        keys: [
          {
            title: 'Nome',
            name: 'patientName',
            class: 'report__table-col--15'
          },
          {
            title: 'Telefone',
            name: 'patientContactPhone',
            class: 'report__table-col--12'
          },
          {
            title: 'Origem',
            name: 'type',
            class: 'report__table-col--17'
          },
          {
            title: 'Tipo',
            name: 'medicalConsultationType',
            class: 'report__table-col--15'
          },
          {
            title: 'Data',
            name: 'agendaAppointmentStart',
            class: 'report__table-col--15'
          },
          {
            title: 'Ações',
            name: 'actions',
            class: 'report__table-col--26'
          }
        ],
        rows: []
      },
      filters: [
        {
          name: 'startDate',
          label: 'Período inicial',
          type: 'date',
          queryString: '&filterAndGreaterThanOrEqual[a.appointmentStart]=#VALUE#',
          value: this.$moment().startOf('day').toISOString()
        },
        {
          name: 'endDate',
          label: 'Período final',
          type: 'date',
          queryString: '&filterAndLessThanOrEqual[a.appointmentFinish]=#VALUE#',
          value: this.$moment().endOf('day').toISOString()
        },
        {
          name: 'status',
          label: 'Status',
          type: 'list',
          queryString: '&filterIn[a.status][]=#VALUE#',
          value: [],
          options: [
            { label: 'Aberto', value: 'ABERTO' },
            { label: 'Em andamento', value: 'EM ANDAMENTO' },
            { label: 'Cancelado pelo paciente', value: 'CANCELADO PELO PACIENTE' },
            { label: 'Cancelado pelo médico', value: 'CANCELADO PELO MEDICO' },
            { label: 'Não compareceu', value: 'NAO COMPARECEU' },
            { label: 'Realizado', value: 'REALIZADO' },
            { label: 'Reagendado', value: 'REAGENDADO' },
            { label: 'Pagamento não aprovado', value: 'PAGAMENTO NAO APROVADO' },
            { label: 'Aguardando confirmação pelo paciente', value: 'AGUARDANDO CONFIRMACAO PELO PACIENTE' }
          ]
        },
        {
          name: 'medicalConsultationType',
          label: 'Tipo de agendamento',
          type: 'list',
          queryString: '&filterIn[a.medicalConsultationType][]=#VALUE#',
          value: [],
          options: [
            { label: 'Consulta', value: 'CONSULTA' },
            { label: 'Retorno', value: 'RETORNO' },
            { label: 'Exame/Procedimento', value: 'EXAME_PROCEDIMENTO' }
          ]
        },
        {
          name: 'type',
          label: 'Tipo de consulta',
          type: 'list',
          queryString: '&filterIn[a.type][]=#VALUE#',
          value: [],
          options: [
            { label: 'Dr. Conecta', value: 'DRCONECTA' },
            { label: 'Dr. Conecta Telemedicina', value: 'DRCONECTA_TELEMEDICINA' },
            { label: 'Particular', value: 'PARTICULAR' },
            { label: 'Particular Telemedicina', value: 'PARTICULAR_TELEMEDICINA' },
            { label: 'Convênio', value: 'CONVENIO' }
          ]
        },
        {
          name: 'name',
          label: 'Nome do paciente',
          placeholder: 'Busque pelo nome',
          type: 'text',
          queryString: '&filterOrLike[0][u.name][]=#VALUE#&filterOrLike[0][sp.name][]=#VALUE#',
          value: null
        }
      ],
      pagination: {
        totalRows: null,
        totalPages: null,
        currentPage: null
      },
      itemsPerPage: 15,
      agendaId: null,
      ui: {
        isLoading: false,
        hasLoaded: false,
        showReceipt: false,
        selectedCol: 'patientContactPhone'
      }
    }
  },

  computed: {
    ...mapGetters({
      isCertificateExpired: 'getNewCertifierCredentialRequired'
    }),

    prefix () {
      return this.fn_IS_DOCTOR()
        ? '/doctor'
        : `/secretary/doctor/${this.$route.params.doctorId}`
    },

    getRows () {
      let arr = []
      for (let row of this.data.rows) {
        let newRow = {}
        for (let field in row) {
          if (this.getSelectedCol && this.fn_IS_MOBILE()) {
            if (field === this.getSelectedCol || field === 'patientName') {
              newRow[field] = row[field] ? row[field] : '(não informado)'
            }
          } else {
            newRow[field] = row[field] ? row[field] : '(não informado)'
          }
        }
        arr.push(newRow)
      }

      return arr
    },

    getSelectedCol () {
      return this.ui.selectedCol
    },

    queryString () {
      return this.filters.reduce((prev, next, i) => {
        let query = ''

        switch (true) {
          case next.type === 'date':
            if (next.value) {
              // query = next.queryString
              //   .replaceAll(
              //     /#VALUE#/gi,
              //     this.$moment(next.value).format('YYYY-MM-DD HH:mm:ss')
              //   )
              query = next.queryString
                .split('#VALUE#')
                .join(this.$moment(next.value).format('YYYY-MM-DD HH:mm:ss'))
            }
            break

          case next.type === 'list':
            if (next.value.length > 0) {
              // query = next.value
              //   .map(i => next.queryString.replaceAll(/#VALUE#/gi, i))
              //   .join('')

              query = next.value
                .map(i => next.queryString.split('#VALUE#').join(i))
                .join('')
            }
            break

          case next.type === 'text':
            if (next.value) {
              // query = next.queryString.replaceAll(/#VALUE#/gi, next.value)
              query = next.queryString.split('#VALUE#').join(next.value)
            }
            break

          default:
            query = ''
            break
        }

        return `${prev}${query}`
      }, '')
    }
  },

  watch: {
    queryString: {
      deep: false,
      immediate: false,
      handler () {
        this.init()
      }
    },

    'ui.isLoading': {
      deep: false,
      immediate: true,
      handler () {
        if (!this.ui.isLoading && this.pagination.currentPage > 1) {
          this.$nextTick(() => {
            document.querySelector('footer.activity')
              .scrollIntoView({
                behavior: 'smooth',
                block: 'end',
                inline: 'nearest'
              })
          })
        }
      }
    }
  },

  mounted () {
    this.init()
  },

  methods: {
    init () {
      this.data.rows = []
      this.pagination = {
        totalRows: null,
        totalPages: null,
        currentPage: null
      }
      this.fetchData()
    },

    fetchData (page = 1) {
      const url = `${
        this.prefix
      }/agenda?itensPerPage=${
        this.itemsPerPage
      }&order[a.appointmentStart]=ASC${
        this.queryString
      }&page=${
        page
      }`

      this.ui.isLoading = true
      this.fn_SHOW_PROGRESS()
      this.$http
        .get(url, this.$store.getters.getAuthHeader)
        .then((res) => {
          const { data, pagination } = res.data
          this.pagination = pagination
          this.data.rows = this.data.rows.some(item => item.agendaId === data[0].agendaId)
            ? data
            : this.data.rows.concat(data)
        })
        .catch(err => console.log(err))
        .finally(() => {
          this.ui.isLoading = false
          this.ui.hasLoaded = true
          this.fn_HIDE_PROGRESS()
        })
    },

    showMore () {
      if (this.pagination.currentPage < this.pagination.totalPages) {
        this.fetchData(this.pagination.currentPage + 1)
      }
    },

    getActions (appointmentIndex) {
      let appointment = {}
      for (let row in this.data.rows) {
        if (parseInt(row) === appointmentIndex) {
          appointment = this.data.rows[row]
        }
      }
      const route = {
        name: 'DoctorAppointmentsDetails',
        params: {
          patientType: appointment.patientType,
          id: appointment.patientId,
          agendaId: appointment.agendaId
        }
      }

      switch (true) {
        case
          /aberto/gi.test(appointment.status) &&
          this.$moment().isSame(appointment.agendaAppointmentStart, 'day'):
          return [
            {
              type: 'label',
              label: 'Iniciar consulta',
              class: 'appointment-label--start',
              fn: this.validateAppointmentStart,
              params: [appointment.type, route]
            },
            {
              type: 'label',
              label: 'Informar ausência',
              class: 'appointment-label--inform-absent',
              fn: this.reportAbsence,
              params: [appointment.doctorOfficeId, appointment.agendaId]
            }
          ]

        case /em andamento/gi.test(appointment.status):
          return [
            {
              type: 'label',
              label: 'Consulta em andamento',
              class: 'appointment-label--on-going',
              route
            }
          ]

        case /cancelado/gi.test(appointment.status):
          return [
            {
              type: 'label',
              label: 'Cancelado',
              class: 'appointment-label--cancelled',
              route
            }
          ]

        case /compareceu/gi.test(appointment.status):
          return [
            {
              type: 'label',
              label: 'Não compareceu',
              class: 'appointment-label--is-absent',
              route
            }
          ]

        case /realizado/gi.test(appointment.status):
          return [
            {
              type: 'label',
              label: 'Atendimento realizado',
              class: 'appointment-label--completed',
              route
            },
            {
              type: 'label',
              label: 'Recibo',
              class: 'appointment-label--receipt',
              fn: this.openReceipt,
              params: [appointment.agendaId]
            }
          ]

        default:
          return [
            {
              type: 'icon',
              icon: 'search',
              route
            }
          ]
      }
    },

    openReceipt (id) {
      this.agendaId = id
      this.ui.showReceipt = true
    },

    reportAbsence (office, agenda) {
      const setAbsence = (officeId, agendaId) => {
        const url = `${this.prefix}/doctor_office/${officeId}/agenda/${agendaId}/absent`

        this.fn_SHOW_PROGRESS()
        this.$http
          .put(url, { status: { status: true } }, this.$store.getters.getAuthHeader)
          .then((res) => {
            this.$store.dispatch('setModalAlert', {
              title: 'Sucesso',
              body: 'Status de não comparecimento registrado com sucesso.',
              size: 'md',
              active: true
            })
          })
          .catch(err => this.fn_HANDLE_ERROR(err))
          .finally(() => {
            this.fn_HIDE_PROGRESS()
            this.init()
          })
      }

      this.$store.dispatch('setModalConfirm', {
        title: 'Confirmação',
        body: 'Deseja confirmar a ausência do paciente?',
        confirmText: 'Confirmar',
        cancelText: 'Cancelar',
        beforeClose (v) {
          if (v) {
            setAbsence(office, agenda)
          }

          this.$store.dispatch('setModalConfirm')
        },
        size: 'md',
        active: true
      })
    },

    validatePeriods () {
      const startDate = this.filters.find(i => i.name === 'startDate')
      const endDate = this.filters.find(i => i.name === 'endDate')

      startDate.value = this.$moment(startDate.value).startOf('day').toISOString()
      endDate.value = this.$moment(endDate.value).endOf('day').toISOString()

      if (this.$moment(startDate.value).isAfter(this.$moment(endDate.value), 'day')) {
        endDate.value = startDate.value
      }

      if (this.$moment(endDate.value).isBefore(this.$moment(startDate.value), 'day')) {
        startDate.value = endDate.value
      }
    },

    validateAppointmentStart (type, route) {
      if (
        /^(?=.*healthplace)(?=.*telemedicin(e|a)).+/gim.test(type) &&
          this.isCertificateExpired
      ) {
        this.$store.dispatch('setModalConfirm', {
          title: 'Atenção',
          body: `Antes de iniciar essa consulta, você precisa validar seu certificado
            de assinatura digital. Isso é importante para que o paciente possa utilizar
            os documentos gerados por você nesta consulta.`,
          confirmText: 'Certificado digital',
          cancelText: 'Cancelar',
          beforeClose: (v) => {
            if (v) {
              this.$router.push({ name: 'DoctorUserCertificates' })
            }

            this.$store.dispatch('setModalConfirm')
          },
          size: 'md',
          active: true
        })

        return
      }

      this.$router.push(route)
    }
  }
}
</script>
